import { render, staticRenderFns } from "./SlRelaunch.vue?vue&type=template&id=b70dc52a&scoped=true&lang=html&"
import script from "./SlRelaunch.vue?vue&type=script&lang=js&"
export * from "./SlRelaunch.vue?vue&type=script&lang=js&"
import style0 from "./SlRelaunch.vue?vue&type=style&index=0&id=b70dc52a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70dc52a",
  null
  
)

export default component.exports